import { constructEmptyData } from '../actions/promotionActions'
const promotionsSupplier = {
  isLoading: {
    detail: true,
    form: false,
    list: true,
  },
  list: [],
  details: constructEmptyData(),
  availableProducts: [],
}
const PromotionsSupplierReducer = function (state = promotionsSupplier, action) {
  switch (action.type) {
    case 'TOGGLE_PROMOTION_LOADING': {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.key]: action.value,
        },
      }
    }
    case 'SET_PROMOTION_LIST': {
      return {
        ...state,
        list: action.value,
      }
    }
    case 'SET_PROMOTION_DETAILS': {
      return {
        ...state,
        details: action.value,
      }
    }
    case 'UPDATE_PROMOTION_DETAILS': {
      return {
        ...state,
        details: {
          ...state.details,
          [action.key]: action.value,
        },
      }
    }
    case 'UPDATE_PROMOTION_AVAILABLE_PRODUCTS': {
      return {
        ...state,
        availableProducts: action.value,
      }
    }
    default: {
      return state
    }
  }
}

export default PromotionsSupplierReducer
